import { useMemo } from 'react';

import { useClusters } from '@cast/shared-cluster-context-data-access';
import { AgentStatus } from '@cast/types';
import { isDemoCluster } from '@cast/utils';

import { useIsOpDemoMode } from '@cast/infrastructure-demo';

type Props = {
  enabled?: boolean;
};

export const useActiveClusters = ({ enabled = true }: Props = {}) => {
  const { clusters, isLoading, hasError, refetchClusters } = useClusters({
    enabled,
  });
  const isOpDemoMode = useIsOpDemoMode();

  const activeClusters = useMemo(() => {
    if (isOpDemoMode) {
      return [];
    }

    return clusters
      ?.filter((cluster) => !isDemoCluster(cluster.id))
      .filter(
        (cluster) =>
          ![AgentStatus.NOT_RESPONDING, AgentStatus.DISCONNECTED].includes(
            cluster.agentStatus
          )
      );
  }, [clusters, isOpDemoMode]);

  return { clusters: activeClusters, isLoading, hasError, refetchClusters };
};
